
<div class="alarm-circle" :type="type">
	<span class="alarm-content"><slot /></span>
</div>
